export default __webpack_public_path__ + "static/banner_hosuton-047aa734128d933331482757a100e2e0.webp";